import {useEffect, useState} from 'react';

// Module-scoped global filter store (global-filter-store-pattern). Fields:
//   state         -> EmissionState (drives listBillableEventsByState when alone)
//   channel       -> BillingChannel (only with dayStart + dayEnd -> listBillableEventsByChannelAndDay)
//   customerId    -> ID (BillableEventsFilterInput)
//   dayStart / dayEnd -> AWSDateTime bounds, only with channel
// No default filter is seeded — admins see all events on first visit.
let globalFilters: Record<string, string> = {};
const filterListeners: Set<(filters: Record<string, string>) => void> = new Set();

const notifyFilterChange = (filters: Record<string, string>) => {
    globalFilters = filters;
    filterListeners.forEach(listener => listener(filters));
};

export const useBillableEventsFilter = () => {
    const [filters, setFilters] = useState<Record<string, string>>(globalFilters);

    useEffect(() => {
        const listener = (newFilters: Record<string, string>) => setFilters(newFilters);
        filterListeners.add(listener);
        // FNP-605: re-read once subscribed, so a change made between render and this
        // effect is not lost.
        setFilters(globalFilters);
        return () => {
            filterListeners.delete(listener);
        };
    }, []);

    const handleSetFilters = (newFilters: Record<string, string>) => {
        notifyFilterChange(newFilters);
    };

    const handleClearFilters = () => {
        notifyFilterChange({});
    };

    return {filters, handleSetFilters, handleClearFilters};
};
